/**
 * Shipments-list owner filter → `owner=` query param (contract §3):
 * '' (All) → omitted, 'me' / 'unassigned' as-is, an ops user id as its number.
 */
export type OwnerFilter = '' | 'me' | 'unassigned' | string;

export function ownerFilterParam(filter: OwnerFilter): string | undefined {
  if (!filter) return undefined;
  if (filter === 'me' || filter === 'unassigned') return filter;
  return /^\d+$/.test(filter) ? filter : undefined;
}
